import { useEffect, useRef, useState } from "react";

const scrollContainer = document.getElementById("root");

export function useLazyVisible<T extends HTMLElement>(options?: any) {
  const ref = useRef<T | null>(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        root: scrollContainer,
        rootMargin: "390px",
        ...options,
      },
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [options]);

  return { ref, isVisible };
}
